module.exports = __webpack_public_path__ + "static/img/app-train-1.048d2500.png";